import { useEffect, useRef, useState } from "react";

const steps = [
  {
    num: "01",
    title: "Velg din badstue",
    desc: "Utforsk våre badstuemodeller og finn den løsningen som passer best for dine behov. Vårt team hjelper deg med å velge riktig størrelse, tak og konfigurasjon. Du kan tilpasse materialer, dører, vinduer og utstyr helt etter dine ønsker.",
    image: "https://media.base44.com/images/public/69a726345560d5ef49a37111/0bcbd7319_LYKKE_MORI_3.png",
    alt: "Steg 1: Velg din LYKKE badstuemodell fra våre tre kolesjoner"
  },
  {
    num: "02",
    title: "Forespørsel",
    desc: "Det første steget er å sende oss en forespørsel med dine kontaktopplysninger og hvilken saunamodell du er interessert i. Vi tar kontakt innen 24 timer med fullt pristilbud og prosjektforslag."
  },
  {
    num: "03",
    title: "Design og avtale",
    desc: "Avtalen spesifiserer alle valgte konfigurasjoner, materialer og leveringstidsfrister. Full forutsigbarhet og sikkerhet gjennom hele prosessen. Vi sikrer at alt er klart før produksjonen starter.",
    image: "https://media.base44.com/images/public/69a726345560d5ef49a37111/c52407d34_Julia_Contract.jpg",
    alt: "Steg 3: Design og avtale – dokumentering av badstueprosjektet"
  },
  {
    num: "04",
    title: "Produksjon",
    desc: "Din badstue bygges i vår moderne produksjonsfasilitet med høyeste kvalitetskontroll. Produksjonstiden er vanligvis 8–12 uker avhengig av modell og konfigurasjon. Vi holder deg oppdatert hele veien.",
    image: "https://media.base44.com/images/public/69a726345560d5ef49a37111/064d6c318_Zrzutekranu2026-03-28o125415.png",
    alt: "Steg 4: Produksjon av badstuen – byggeprosess og kvalitetskontroll"
  },
  {
    num: "05",
    title: "Levering",
    desc: "Din ferdigtilvirket badstue leveres direkte til byggeplassen, ferdig pakket og beskyttet for transport. Vi koordinerer logistikken slik at alt går fryktelsfritt.",
    image: "https://media.base44.com/images/public/69a726345560d5ef49a37111/d38bc4a79_Transport_House_Nomad35.jpg",
    alt: "Steg 5: Levering – transport av ferdigbygd badstue"
  },
  {
    num: "06",
    title: "Montering og tilkobling",
    desc: "Badstuen settes opp på forberedt fundament og kobles til strøm, varmingsanlegg og eventuell vannforsyning. Komplett teknisk dokumentasjon og garantibevis. Badstuen er klar til bruk samme dag i de fleste tilfeller.",
    image: "https://media.base44.com/images/public/69a726345560d5ef49a37111/e90d3bf11_Assembling_House_Norway.jpg",
    alt: "Steg 6: Montering – profesjonell installasjon av badstuen"
  }
];


export default function ProcessSection() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setVisible(true);},
      { threshold: 0.05 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="prosess" ref={ref} className="py-24 md:py-40 bg-secondary/50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="mb-24">
          <p className="text-sm tracking-widest-2xl font-body uppercase text-primary mb-6">
            Prosessen
          </p>
          <h2 className="font-heading text-4xl md:text-6xl font-light leading-[1.1]">
            Fra forespørsel
            <br />
            <span className="italic">til badstuen din</span>
          </h2>
        </div>

        <div className="space-y-16 md:space-y-24">
          {steps.map((step, i) => (
            <div
              key={i}
              className={`transition-all duration-700 max-w-2xl ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
              }`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <span className="font-heading text-5xl md:text-6xl lg:text-7xl font-light text-[#a6b894]/40">
                {step.num}
              </span>
              <h3 className="font-heading text-3xl md:text-4xl font-light mt-6 mb-6 text-[#2a1810]">
                {step.title}
              </h3>
              <p className="font-body text-2xl leading-relaxed text-foreground/70">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );

}